"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../BaseComponent");
var HegydCore_1 = require("./hegyd/hegyd-core/HegydCore");
var sweetalert2_js_1 = require("sweetalert2/dist/sweetalert2.js");
var toastr = require("toastr");
var DeleteAccount = /** @class */ (function (_super) {
    __extends(DeleteAccount, _super);
    function DeleteAccount($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        return _this;
    }
    DeleteAccount.prototype.bind = function () {
        var _this = this;
        this.$view.on('click', 'a', function (e) {
            e.preventDefault();
            sweetalert2_js_1.default({
                title: $(e.target).data('title'),
                allowOutsideClick: true,
                text: $(e.target).data('text'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: "#D2282D",
                cancelButtonText: $(e.target).data('cancel'),
                confirmButtonText: $(e.target).data('comfirm')
            }).then(function (result) {
                if (result.value) {
                    HegydCore_1.default.sendRequest($(e.target).attr('href'), 'POST', {}, function (response) {
                        toastr.success(response.message);
                        _this.$view.empty().html(response.view);
                    });
                }
            });
        });
    };
    return DeleteAccount;
}(BaseComponent_1.default));
exports.default = DeleteAccount;
